import { useEffect, useState } from 'react';
import { useSolicitud } from '../../../hooks/useSolicitud';
import FormSelectBox from '../../../components/Form/FormSelectBox';
import Confirm from '../../../components/Confirm';
import { Solicitud } from '../../../classes/Solicitud';
import { useAuth } from '../../../hooks/useAuth';
import { Usuario } from '../../../types/Usuario';
import { Breadcrumbs } from '../../Home/Breadcrumb';
import { TipoInicioSelector } from './components/TipoInicioSelector';
import { InicioPorContratista } from './components/InicioPorContratista';
import { InicioPorTipoTrabajo } from './components/InicioPorTipoTrabajo';
import { ContratistaTrabajoEmpresa } from '../../../types/ContratistaTrabajoEmpresa';

export const CrearSolicitud = () => {
  const { getUsuarioLogueado } = useAuth();
  const [empresasGestoras, setEmpresasGestoras] = useState<any>({});
  const [tiposTrabajos, setTiposTrabajos] = useState<any>([]);
  const [idEmpresaGestora, setIdEmpresaGestora] =
    useState<string>('');
  const [idContratista, setIdContratista] = useState<string>('');
  const [contratistas, setContratistas] = useState<any>({});
  const [setTiposDocumentos] = useState<any>({});
  const [showModal, setShowModal] = useState<boolean>(false);
  const [tipoTrabajoSelected, setTipoTrabajoSelected] = useState<any>(
    {}
  );
  const [usuarioLogin] = useState<Usuario>(getUsuarioLogueado());

  // Nuevos estados para Empresa Gestora
  const [tipoInicio, setTipoInicio] = useState<
    'contratista' | 'tipoTrabajo'
  >('contratista');
  const [trabajosEmpresa, setTrabajosEmpresa] = useState<any>([]);
  const [idTrabajoEmpresa, setIdTrabajoEmpresa] =
    useState<string>('');
  const [contratistasTrabajoEmpresa, setContratistasTrabajoEmpresa] =
    useState<ContratistaTrabajoEmpresa[]>([]);
  const [contratistaSelected, setContratistaSelected] =
    useState<ContratistaTrabajoEmpresa | null>(null);

  const {
    cargarCombo,
    cargarTipoTrabajo,
    handleInitSolicitud,
    cargarEmpresasGestoras,
    cargarContratistas,
    cargarTrabajosEmpresaPorGestora,
    cargarContratistasPorTrabajoEmpresa,
  } = useSolicitud();

  useEffect(() => {
    // cargarCombo('contratistas', setContratistas);
    cargarCombo('tiposDocumentos', setTiposDocumentos);

    if (usuarioLogin.tipoUsuarioValor === 'CONTRATISTA') {
      cargarEmpresasGestoras(
        'empresasGestoras',
        `${usuarioLogin.idContratista}`,
        setEmpresasGestoras
      );
    } else {
      // Empresa Gestora
      cargarContratistas(
        'contratistas',
        `${usuarioLogin.idEmpresaGestora}`,
        setContratistas
      );
      // Cargar trabajos empresa para el combo de "Inicio por Tipo de Trabajo"
      cargarTrabajosEmpresaPorGestora(
        `${usuarioLogin.idEmpresaGestora}`,
        setTrabajosEmpresa
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleChangeGestora = (e: any) => {
    e.preventDefault();
    const eg = e.target.value;
    setIdEmpresaGestora(eg);
    setIdContratista(`${usuarioLogin.idContratista}`);
    cargarTipoTrabajo(
      'tiposTrabajos',
      eg,
      `${usuarioLogin.idContratista}`,
      setTiposTrabajos
    );
  };

  const handleChangeContratista = (e: any) => {
    e.preventDefault();
    const contratistaID = e.target.value;
    setIdContratista(contratistaID);
    setIdEmpresaGestora(`${usuarioLogin.idEmpresaGestora}`);
    cargarTipoTrabajo(
      'tiposTrabajos',
      `${usuarioLogin.idEmpresaGestora}`,
      contratistaID,
      setTiposTrabajos
    );
  };

  // Nuevo handler para cambio de trabajo empresa
  const handleChangeTrabajoEmpresa = (e: any) => {
    e.preventDefault();
    const trabajoEmpresaID = e.target.value;
    setIdTrabajoEmpresa(trabajoEmpresaID);

    // Cargar contratistas asociados a este trabajo empresa
    if (trabajoEmpresaID) {
      cargarContratistasPorTrabajoEmpresa(
        trabajoEmpresaID,
        setContratistasTrabajoEmpresa
      );

      // Obtener el tipo de trabajo del trabajo empresa seleccionado
      const trabajoEmpresaSeleccionado = trabajosEmpresa.find(
        (te: any) => te.id === Number(trabajoEmpresaID)
      );
      if (trabajoEmpresaSeleccionado) {
        setTipoTrabajoSelected({
          id: trabajoEmpresaSeleccionado.idTipoTrabajo,
          descripcion: trabajoEmpresaSeleccionado.tipoTrabajo,
        });
      }
    } else {
      setContratistasTrabajoEmpresa([]);
    }
  };

  // Handler para seleccionar tipo de inicio
  const handleTipoInicioChange = (
    tipo: 'contratista' | 'tipoTrabajo'
  ) => {
    setTipoInicio(tipo);
    // Limpiar estados según la opción seleccionada
    if (tipo === 'contratista') {
      setIdTrabajoEmpresa('');
      setContratistasTrabajoEmpresa([]);
      setContratistaSelected(null);
    } else {
      setIdContratista('');
      setTiposTrabajos([]);
      setTipoTrabajoSelected({});
    }
  };

  const toggle = () => setShowModal(!showModal);

  const iniciarSolicitud = () => {
    const solicitud: Solicitud = {} as Solicitud;

    if (usuarioLogin.tipoUsuarioValor === 'CONTRATISTA') {
      solicitud.idContratista = Number(idContratista);
      solicitud.idEmpresaGestora = Number(idEmpresaGestora);
      solicitud.idTipoTrabajo = tipoTrabajoSelected.id;
    } else {
      // Empresa Gestora
      if (tipoInicio === 'contratista') {
        solicitud.idContratista = Number(idContratista);
        solicitud.idEmpresaGestora = Number(
          usuarioLogin.idEmpresaGestora
        );
        solicitud.idTipoTrabajo = tipoTrabajoSelected.id;
      } else {
        // Inicio por tipo de trabajo
        if (contratistaSelected) {
          solicitud.idContratista = Number(
            contratistaSelected.idContratista
          );
          solicitud.idEmpresaGestora = Number(
            usuarioLogin.idEmpresaGestora
          );
          solicitud.idTipoTrabajo = tipoTrabajoSelected.id;
        }
      }
    }

    handleInitSolicitud(solicitud);
  };

  return (
    <>
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <Breadcrumbs
              title={'Alta de Solicitud'}
              nameFirst={'Consulta de Solicitudes'}
              urlFirst={'/consultaSolicitudes'}
            />
            <div className="form-horizontal">
              <div className="row">
                <Confirm
                  isOpen={showModal}
                  toggle={toggle}
                  title="Confirmar"
                  yesFn={iniciarSolicitud}
                >
                  <div className="form-horizontal">
                    <div className="row">
                      {
                        <p>
                          Está seguro que desea iniciar la solicitud?
                        </p>
                      }
                    </div>
                  </div>
                </Confirm>

                {/* Mostrar selector de tipo de inicio solo para Empresa Gestora */}
                {usuarioLogin.tipoUsuarioValor !== 'CONTRATISTA' && (
                  <TipoInicioSelector
                    tipoInicio={tipoInicio}
                    onChange={handleTipoInicioChange}
                  />
                )}

                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      {usuarioLogin.tipoUsuarioValor ===
                      'CONTRATISTA' ? (
                        // Vista para CONTRATISTA (mantiene la funcionalidad actual)
                        <>
                          <div className="d-flex justify-content-center">
                            <FormSelectBox
                              title={'Empresa Gestora'}
                              label={'empresa gestora'}
                              id={'empresaGestora'}
                              name={'idEmpresaGestora'}
                              onChange={handleChangeGestora}
                              optionId={'id'}
                              optionLabel={'nombreEmpresa'}
                              value={idEmpresaGestora}
                              options={empresasGestoras}
                              classLabel="col-form-label col-2 text-left"
                              classDivSelect="col-8"
                              styleLabelColor="black"
                            />
                          </div>
                          <div className="row mt-3">
                            <label className="col-form-label">
                              Tipos de Trabajo
                            </label>

                            <div className="ms-2 p-3 card p-5">
                              <div className="row">
                                {tiposTrabajos?.map(
                                  (tipoTrabajo: any) => {
                                    return (
                                      <div
                                        className="col-3 text-center"
                                        key={tipoTrabajo.id}
                                      >
                                        <a
                                          href="/tipoTrabajo"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setShowModal(true);
                                            setTipoTrabajoSelected(
                                              tipoTrabajo
                                            );
                                          }}
                                        >
                                          <img
                                            src={`data:image/jpeg;base64,${tipoTrabajo.logo}`}
                                            alt={tipoTrabajo.id}
                                            width="100"
                                            height="100"
                                          />
                                          <br />
                                          <span className="fs-9">
                                            {tipoTrabajo.descripcion}
                                          </span>
                                        </a>
                                      </div>
                                    );
                                  }
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        // Vista para EMPRESA GESTORA con dos opciones
                        <>
                          {tipoInicio === 'contratista' ? (
                            <InicioPorContratista
                              contratistas={contratistas}
                              idContratista={idContratista}
                              tiposTrabajos={tiposTrabajos}
                              onChangeContratista={
                                handleChangeContratista
                              }
                              onSelectTipoTrabajo={(tipoTrabajo) => {
                                setShowModal(true);
                                setTipoTrabajoSelected(tipoTrabajo);
                              }}
                            />
                          ) : (
                            <InicioPorTipoTrabajo
                              trabajosEmpresa={trabajosEmpresa}
                              idTrabajoEmpresa={idTrabajoEmpresa}
                              contratistas={
                                contratistasTrabajoEmpresa
                              }
                              onChangeTrabajoEmpresa={
                                handleChangeTrabajoEmpresa
                              }
                              onSelectContratista={(contratista) => {
                                setShowModal(true);
                                setContratistaSelected(contratista);
                              }}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
